import { render, staticRenderFns } from "./SupplierRowBlock.vue?vue&type=template&id=51bd2fe1"
import script from "./SupplierRowBlock.vue?vue&type=script&lang=js"
export * from "./SupplierRowBlock.vue?vue&type=script&lang=js"
import style0 from "./SupplierRowBlock.vue?vue&type=style&index=0&id=51bd2fe1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports